import { useOutletContext } from "react-router-dom";
import { FeeManager } from "@dealer-center/core-feemanager-react";
import { useCC9Flags } from "@dealer-center/core-third-party-launch-darkly";
import type { ControlcenterAPIInterfaceExternal } from "@dealer-center/ddc-pages-controlcenter-interface";
import type { decodedJwtAndPermissions } from "@dealer-center/ddc-api-user-interface";

export const DdcFeeManager = () => {
  const { userEntity, ccUserInfo } = useOutletContext<{
    ccUserInfo: ControlcenterAPIInterfaceExternal;
    userEntity: decodedJwtAndPermissions;
  }>();
  const { "fee-manager-access": isFeeManagerEnabled } = useCC9Flags();

  const tenantId = ccUserInfo?.accountId ?? "";
  const tenantUser = ccUserInfo?.internalUserId ?? ccUserInfo?.userId ?? "";

  // ccUserInfo absence (misconfigured route) denies access even via the LD path.
  // LD flag grants access to any user regardless of internal status (user-level targeting).
  // Permissions path requires internal=true; both accountPermissions and userPermissions must include INVENTORY.FEEMANAGER.
  const hasAccess =
    !!ccUserInfo &&
    tenantId.toLowerCase() !== "ddc" &&
    (isFeeManagerEnabled === true ||
      (userEntity?.internal === true &&
        ccUserInfo.accountPermissions.includes("INVENTORY.FEEMANAGER") &&
        ccUserInfo.userPermissions.includes("INVENTORY.FEEMANAGER")));

  return (
    <FeeManager
      basePath="/landing/nxlambda/feeManager"
      clientId="dealercenter"
      hasAccess={hasAccess}
      tenantId={tenantId}
      tenantType="DDC"
      tenantUser={tenantUser}
    />
  );
};
